import type { FunctionComponent } from "react";

import { paywall } from "shared/data";

import { DefaultContentTypes } from "scmp-app/components/search/consts";
import type { ContentTypeEnum } from "scmp-app/queries/__generated__/searchArticleResultPaginationQuery.graphql";

import IconCheckboxChecked from "./icon-checkbox-checked.svg";
import IconCheckboxOff from "./icon-checkbox-off.svg";
import { BoldWord, Checkbox, Container, Content } from "./styles";

type Props = {
  checked: boolean;
  onChange: (change: {
    articleTypeIds: string[];
    articleTypeText: string;
    contentTypes: ContentTypeEnum[];
    paywallTypeIds: string[];
    sectionIds: string[];
  }) => void;
};

export const PlusCheckboxField: FunctionComponent<Props> = ({ checked, onChange }) => {
  const handleClick = () => {
    const nextChecked = !checked;
    onChange({
      articleTypeIds: [],
      articleTypeText: "All",
      contentTypes: nextChecked ? ["ARTICLE"] : [...DefaultContentTypes],
      paywallTypeIds: nextChecked ? [paywall.scmpPlus.entityUuid] : [],
      sectionIds: [],
    });
  };

  return (
    <Container onClick={handleClick}>
      <Checkbox>{checked ? <IconCheckboxChecked /> : <IconCheckboxOff />}</Checkbox>
      <Content>
        Only show<BoldWord> SCMP Plus </BoldWord>articles
      </Content>
    </Container>
  );
};

PlusCheckboxField.displayName = "PlusCheckboxField";
